<template>
  <div class="page-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>发票抬头列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="card-box" shadow="hover" style="margin-top: 20px">
      <!-- 搜索 新增 -->
      <div class="search-wrapper">
        <el-form
          size="mini"
          :inline="true"
          :model="searchForm"
          ref="searchForRef"
          label-width="80px"
          autocomplete="on"
        >
          <!-- 门店选择 -->
          <!-- <el-form-item label="所属门店" size="small">
            <el-select
              v-model="searchForm.shop_id"
              filterable
              clearable
              placeholder="搜索门店/地址/联系人"
              style="width: 260px"
              :filter-method="shopFilterMethod"
              popper-class="shop-select-dropdown"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                class="shop-option-item"
              >
                <div class="shop-option">
                  <div class="shop-name">{{ item.name }}</div>
                  <div class="shop-info">
                    <span>地址：{{ item.address || '无' }}</span>
                    <span>联系人：{{ item.contact || '无' }}</span>
                  </div>
                </div>
              </el-option>
            </el-select>
          </el-form-item> -->

          <!-- 发票类型 -->
          <el-form-item label="发票类型">
            <el-select
              v-model="searchForm.invoice_type"
              clearable
              placeholder="全部类型"
              style="width: 140px"
            >
              <el-option label="增值税专票" value=1></el-option>
              <el-option label="增值税普票" value=2></el-option>
              <el-option label="电子普通发票" value=3></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="单位名称">
            <el-input v-model="searchForm.name" placeholder="单位名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="税号">
            <el-input v-model="searchForm.tax_id" placeholder="税号" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="success" size="mini" @click="searchSubmit">搜索</el-button>
            <el-button type="primary" size="mini" @click="addData">新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <el-table
        :data="tableLoadData"
        size="mini"
        border
        row-key="id"
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="50" align="center"></el-table-column>
      
        <el-table-column label="单位名称" prop="name" min-width="200" :show-overflow-tooltip="true" />
        <el-table-column label="税号" prop="tax_id" min-width="200" :show-overflow-tooltip="true" />
        <el-table-column label="手机号" prop="mobile" width="120" />
        <el-table-column label="邮箱" prop="email" width="180" />
        <el-table-column label="发票类型" width="130" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.invoice_type == 1 ? 'primary' : scope.row.invoice_type == 2 ? 'success' : 'warning'">
              {{ scope.row.invoice_type == 1 ? '专票' : scope.row.invoice_type == 2 ? '普票' : '电子票' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="默认" width="90" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.is_default == 1"
              active-color="#13ce66"
              inactive-color="#ff4949"
            />
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" text @click="goEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" text @click="goDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper" style="margin-top: 20px; text-align: right">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10,20,30,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-card>

    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" size="mini" label-width="100px">
        <!-- 门店选择 -->
        <!-- <el-form-item label="所属门店">
          <el-select
            v-model="form.shop_id"
            filterable
            clearable
            placeholder="选择门店"
            style="width: 100%"
            :filter-method="shopFilterMethod"
          >
            <el-option
              v-for="item in shopList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <!-- 发票类型 -->
        <el-form-item label="发票类型" prop="invoice_type">
          <el-select v-model="form.invoice_type" placeholder="请选择发票类型" style="width: 100%">
            <el-option label="增值税专票" :value='1'></el-option>
            <el-option label="增值税普票" :value='2'></el-option>
            <el-option label="电子普通发票" :value='3'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="单位名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入单位全称"></el-input>
        </el-form-item>
        <el-form-item label="税号" prop="tax_id">
          <el-input v-model="form.tax_id" placeholder="纳税人识别号"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.mobile" placeholder="接收发票短信"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" placeholder="接收电子发票"></el-input>
        </el-form-item>
        <el-form-item label="设为默认">
          <el-switch v-model="form.is_default" active-color="#13ce66" inactive-color="#ff4949" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset_dialogForm('form')">取消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('form')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "InvoiceList",
  data() {
    return {
      // 门店列表
      shopList: [],
      // 搜索
      searchForm: {
        name: "",
        tax_id: "",
        shop_id: "",
        invoice_type: '',
      },
      // 列表数据
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,

      // 弹窗
      dialogFormVisible: false,
      title: "",
      form: {
        shop_id: "",
        invoice_type: 1,
        name: "",
        tax_id: "",
        mobile: "",
        email: "",
        is_default: false,
        id: "",
      },

      // 验证
      rules: {
        shop_id: [{ required: true, message: "请选择门店", trigger: "change" }],
        invoice_type: [{ required: true, message: "请选择发票类型", trigger: "change" }],
        name: [{ required: true, message: "请输入单位名称", trigger: "blur" }],
        tax_id: [{ required: true, message: "请输入税号", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getShopList();
    this.DataList();
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return "";
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  methods: {
    // 门店搜索过滤
    shopFilterMethod(query, item) {
      if (!query) return true;
      const txt = ((item.name || "") + (item.address || "")).toLowerCase();
      return txt.includes(query.toLowerCase());
    },

    // 获取门店列表
    getShopList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
      };
      this.$axios.shopList(param).then((res) => {
        if (res.code === 200) this.shopList = res.data;
      });
    },

    // 发票列表
    DataList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        shop_id: this.searchForm.shop_id,
        name: this.searchForm.name,
        tax_id: this.searchForm.tax_id,
        invoice_type: this.searchForm.invoice_type,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$axios.shopInvoiceListP(param).then((res) => {
        if (res.code === 200) {
          this.tableLoadData = res.data.data;
          this.total = res.data.total;
        }
      });
    },
   goDel(row) {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        id:row.id
      };
      this.$axios.shopInvoiceDel(param).then((res) => {
        if (res.code === 200) {
            this.$message.success("操作成功");
            this.DataList();
        }
      });
    },
    
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.DataList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.DataList();
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },

    // 搜索
    searchSubmit() {
      this.pageNum = 1;
      this.DataList();
    },

    // 新增
    addData() {
      this.title = "新增发票抬头";
      this.form = {
        shop_id: "",
        invoice_type: "",
        name: "",
        tax_id: "",
        mobile: "",
        email: "",
        is_default: false,
        id: "",
      };
      this.dialogFormVisible = true;
    },

    // 编辑
    goEdit(row) {
      this.title = "编辑发票抬头";
      this.form = { ...row };
      this.form.is_default = row.is_default == 1;
      this.dialogFormVisible = true;
    },

    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        const param = {
          id: this.form.id || "",
          shop_id: this.form.shop_id,
          invoice_type: this.form.invoice_type,
          name: this.form.name,
          tax_id: this.form.tax_id,
          mobile: this.form.mobile,
          email: this.form.email,
          is_default: this.form.is_default ? 1 : 0,
          company_id: sessionStorage.getItem("company_id"),
          access_token: sessionStorage.getItem("token"),
        };
        if(this.form.id&&this.form.id>0){
          this.$axios.shopInvoiceEdit(param).then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.dialogFormVisible = false;
            this.DataList();
          } else {
            this.$message.error(res.msg);
          }
        });

        }else{

          this.$axios.shopInvoiceAdd(param).then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.dialogFormVisible = false;
            this.DataList();
          } else {
            this.$message.error(res.msg);
          }
        });

        }
        
      });
    },

    // 重置弹窗
    reset_dialogForm(formName) {
      this.dialogFormVisible = false;
      this.$nextTick(() => this.$refs[formName].resetFields());
    },
  },
};
</script>

<style scoped>
.page-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
}
.page-breadcrumb {
  margin-bottom: 15px;
}
.card-box {
  border-radius: 8px;
  padding: 20px;
}
.search-wrapper {
  margin-bottom: 20px;
}
.pagination-wrapper {
  text-align: right;
}
</style>